import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e088e19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod-title mt-2" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column flex-lg-row flex-md-row align-items-start\" data-v-1e088e19><div class=\"title-preloader rounded\" data-v-1e088e19></div><div class=\"d-flex mt-lg-0 mt-md-0 mt-1 ms-lg-1 ms-md-1 ms-0\" data-v-1e088e19><div class=\"version-header-badge rounded px-2 py-1\" data-v-1e088e19></div><div class=\"ms-2 author-header-badge rounded px-2 py-1\" data-v-1e088e19></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}